import { useOnMount } from "hooks/useOnMount";
import { coreService } from "services/CoreService";
import { schemaService } from "services/SchemaService";

const loadBlockingResources = async () => {
  try {
    const userLoaded = await coreService.getCurrentUser();
    if (userLoaded) {
      coreService.setAppLoaded(true);
    } else {
      coreService.setAppError({
        name: "AppOnLoad",
        message: "App failed to Load",
      });
    }
  } catch (e) {
    coreService.setAppError(e);
  }
};

const OnLoad = () => {
  const mount = async () => {
    await loadBlockingResources();
    schemaService.loadSchema();
  };
  useOnMount(() => {
    mount();
  });
  return null;
};

export default OnLoad;
